module.exports = __webpack_public_path__ + "iconaDOMANDA.svg?34c96c323b80dc77d13ab8f0b2019b0e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconaDOMANDA.svg
// module id = 795
// module chunks = 0